module.exports = __webpack_public_path__ + "img/moncash_large.daad7d45.png";